import { CTA } from '@volkswagen-onehub/components-core';
import { Download } from '@volkswagen-onehub/icons-core';
import { useTribalContext } from '@/context/tribal';
import useGlobalStore, { GlobalStoreStateConfiguration } from '@/stores/globalStore';
import usePdb from '@/hooks/usePdb';
import { performVWBasicDownloadLinkClick } from '@/analytics/events';
import { useLocation } from 'react-router-dom';
import { getActiveConfiguration } from '@/modules/utils/storeUtils';

interface Props {
  sectionName?: string;
}

const CTADownloadBrochure = (props: Props) => {
  const { contentManager, analyticsManager, analyticsBuilder } = useTribalContext();
  const location = useLocation();
  const { app } = useGlobalStore();
  const activeConfiguration: GlobalStoreStateConfiguration | undefined = getActiveConfiguration(app);

  const { configurations, retailers, pdbId } = useGlobalStore(
    (state) => state.app
  );
  const { pdfUrl } = usePdb({ pdbId });
  const { sectionName } = props;

  const text = contentManager.get('ctas-download-brochure');

  return (
    <CTA
      tag="a"
      emphasis="tertiary"
      icon={<Download />}
      iconPosition="end"
      href={pdfUrl}
      {...props}
      onClick={() =>
        performVWBasicDownloadLinkClick({
          label: text,
          sectionName,
          ...(!location.pathname.includes('compare') && {configuration: activeConfiguration}),
          ...(location.pathname.includes('compare') && {configurations}),
          retailers,
          analyticsManager,
          analyticsBuilder,
        })
      }
    >
      {text}
    </CTA>
  );
};

export default CTADownloadBrochure;
